import React, { useState } from 'react';
import classNames from 'classnames';
import css from './styles.module.scss';
import { Box, Collapse, CollapseProps, ListItem, ListItemText } from '@material-ui/core';
import { BoxProps } from '@material-ui/core/Box/Box';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

type CollapsibleBlockProps = BoxProps & {
    collapseProps?: CollapseProps;
};

export const CollapsibleBlock: React.FC<CollapsibleBlockProps> = ({
    children,
    className,
    collapseProps,
    ...props
}) => {
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    return (
        <Box className={classNames(css.module, className)} {...props}>
            <Collapse in={isAccordionOpen} timeout="auto" unmountOnExit {...collapseProps}>
                {children}
            </Collapse>
            <ListItem button onClick={() => {setIsAccordionOpen(!isAccordionOpen)}}>
                <ListItemText primary={`Show ${isAccordionOpen ? 'less' : 'more'}`} />
                {isAccordionOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
        </Box>
    );
};
